import axios from "axios";
import { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "./clients.css";
import ClientsData from "./dataFiles/ClientsData";
const Clients = () => {
    

  const [loader,setLoader]=useState(true)
  const [data, setData] = useState([]);
  useEffect(()=>{if(ClientsData){setLoader(false)}},[])
  const getApi = () => {
    setLoader(true);
    const config = {
      url: "https://bestdealelectricalsbackend.onrender.com/bestdealelectricals/clients",
      method: "get",
      headers: {},
    };
    axios(config)
      .then((res) => {
        setLoader(false)
        setData(res.data.data);
      })
      .catch((err) => {
        setLoader(false)
        console.log("err", err);
      });
  };
  useEffect(() => {
    getApi();
  }, []);
 const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
        {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  return (
    <>
     
        {loader ?  (<><div className="loader"></div></>) : (
           <section className="pt-3">
        <div className="container ">
          <div className="slider-container">
            <Slider {...settings}>
              {data?.map((items) => {
                return (
                 <div className="" key={items._id}>
                     <div className="d-flex justify-content-center align-items-center  clients-container ms-3 p-4 ">
                    <img src={items.image} className="clients-image" />
                  </div>
                 </div>
                );
              })}
            </Slider>
          </div>
             </div>
      </section>
          )}
     
    </>
  );
};
export default Clients;
